import { JWT_TOKEN } from "./constants";

export function getRequestOptions() {
    const jwt = localStorage.getItem(JWT_TOKEN);
    const options = jwt ? {
        headers: {
            "Authorization": `Bearer ${jwt}`
        }
    } : {};

    return options;
}

export function formatTime(totalMs: number) {
  if (isNaN(totalMs) || totalMs < 0) totalMs = 0;

  const hours = Math.floor(totalMs / 3600000);
  const minutes = Math.floor((totalMs % 3600000) / 60000);
  const seconds = Math.floor((totalMs % 60000) / 1000);
  const ms = Math.floor(totalMs % 1000);

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");
  const mmm = String(ms).padStart(3, "0");

  return `${hh}:${mm}:${ss}.${mmm}`;
}